import {Card, Row, Col} from 'antd';
import {GRAMS_PER_LB} from "../../util/unitutils";
import {fixedToDisplayUnit} from "../../util/unitutils";

export const BulkTotalWidget = ({inventory, props}) => {
    let grams = 0, pounds = 0;
    for (let i=0; i<inventory.length; i++) {
        if (!inventory[i].quantity) {
            continue;
        }

        grams += fixedToDisplayUnit(inventory[i].quantity, inventory[i].unit)
    }

    const rowStyle = {paddingTop: '5px', paddingBottom: '5px', textAlign: 'left'}

    pounds = (grams / GRAMS_PER_LB).toFixed(2)
    return <Card>
        <Row style={rowStyle}>
            <Col span={3}>Total grams:</Col>
            <Col>{grams}</Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={3}>Total lbs:</Col>
            <Col>{pounds}</Col>
        </Row>
    </Card>

}